import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateTime } from 'luxon';
import {
	AddOnBilling,
	BillingContract,
} from 'src/app/models/billingContractAndOptions';
import { ApiService } from 'src/app/services/api.services';
import { AppTabNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { QueryStringTabGroupDirective } from '../../../directives/query-string-tab-group.directive';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';
import { BillingEditContractComponent } from '../billing-edit-contract/billing-edit-contract.component';

@Component({
	selector: 'app-billing-contract-details',
	templateUrl: './billing-contract-details.component.html',
	styleUrls: ['./billing-contract-details.component.scss'],
	imports: [
		AppTabNavigationHeaderComponent,
		MatTabGroup,
		QueryStringTabGroupDirective,
		MatTab,
		BreadcrumbLabelDirective,
		BillingEditContractComponent,
	],
})
export class BillingContractDetailsComponent {
	billingContractId = this.route.snapshot.params.id;
	savedBillingContract!: BillingContract;
	editingBillingSettings: boolean =
		this.route.snapshot.params.action === 'edit';

	constructor(
		private readonly route: ActivatedRoute,
		private readonly apiService: ApiService
	) {
		this.getBillingContract();
	}

	async getBillingContract() {
		const allBillingInfoForCustomer =
			await this.apiService.getBillingContractById(this.billingContractId);
		this.savedBillingContract = {
			...allBillingInfoForCustomer.billingSettingsResult,
			billingStartDate: DateTime.fromISO(
				allBillingInfoForCustomer.billingSettingsResult.billingStartDate.split(
					'T'
				)[0]
			).toJSDate(),
			addOnBilling:
				allBillingInfoForCustomer.addOnBillingSettingsResult as unknown as AddOnBilling[],
		} as unknown as BillingContract;
	}
}
